export const imageSchema = {
    displayName: 'image',
    type: 'object',
    fields: {
        url: {
            type: 'url',
            required: true,
        },
        origUrl: {
            type: 'url',
            required: true,
        },
        width: {
            type: 'int',
            min: 1,
            required: true,
        },
        height: {
            type: 'int',
            min: 1,
            required: true,
        },
        origWidth: {
            type: 'int',
            min: 1,
            required: true,
        },
        origHeight: {
            type: 'int',
            min: 1,
            required: true,
        },
        posUrl: {
            type: 'url',
            isReadOnly: true,
        },
    },
};
//# sourceMappingURL=image_schema.js.map